import { jsx as _jsx } from "react/jsx-runtime";
import { omit } from 'ramda';
import { styled } from '../../utils';
import { CardHeader } from '../Card';
export function CardEditEntity(props) {
    return _jsx(CardEditEntityStyled, { ...omit(['editable'], props) });
}
function entityVariantStyle(props, theme) {
    switch (props.variant) {
        case 'add':
            return {
                color: theme.palette.secondary.main,
                '&:hover': {
                    cursor: 'pointer',
                    backgroundColor: theme.palette.groupPrimary.zurichAzure,
                },
                '& .MuiCardHeader-title': {
                    color: theme.palette.secondary.main,
                },
                '& .MuiCardHeader-avatar': {
                    color: theme.palette.secondary.main,
                },
            };
        case 'disable':
            return {
                color: theme.palette.secondary.light,
                '& .MuiCardHeader-avatar': {
                    color: theme.palette.secondary.light,
                },
                '& .MuiCardHeader-title': {
                    color: 'inherit',
                },
            };
        case 'standard':
        default:
            return {
                color: props.open || props.editable
                    ? theme.palette.primary.dark
                    : theme.palette.secondary.main,
            };
    }
}
// TODO: Move this behaviors to common
const CardEditEntityStyled = styled(CardHeader, {
    shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'open' && prop !== 'editable',
})(({ theme, ...props }) => ({
    ...entityVariantStyle(props, theme),
}));
